import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, getSpacing, lineHeight, transitionDuration } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "SearchItemListstyle__Container",
  componentId: "sc-1di9gp6-0"
})(["display:flex;flex-direction:column;width:100%;max-height:260px;padding:", ";overflow-y:scroll;border:1px solid ", ";border-radius:", ";&::-webkit-scrollbar{width:16px;}&::-webkit-scrollbar-thumb{background-color:", ";background-clip:padding-box;border:solid 4px transparent;border-radius:20px;}::-webkit-scrollbar-track{background:transparent;}"], getSpacing(1), colorUsage.searchItemList.borderColor, borderRadius.medium, colorUsage.searchItemList.scrollbarColor);
var ImageWrapper = styled.div.withConfig({
  displayName: "SearchItemListstyle__ImageWrapper",
  componentId: "sc-1di9gp6-1"
})(["position:relative;width:25%;"]);
var IconWrapper = styled.span.withConfig({
  displayName: "SearchItemListstyle__IconWrapper",
  componentId: "sc-1di9gp6-2"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);opacity:0;transition:opacity ", ";& path{fill:", ";}"], transitionDuration["default"], colorUsage.searchItemList.hoverItemIconColor);
var Image = styled.img.withConfig({
  displayName: "SearchItemListstyle__Image",
  componentId: "sc-1di9gp6-3"
})(["display:block;width:100%;border-radius:", ";"], borderRadius.medium);
var TextWrapper = styled.div.withConfig({
  displayName: "SearchItemListstyle__TextWrapper",
  componentId: "sc-1di9gp6-4"
})(["width:75%;margin-left:", ";padding:", ";color:", ";font-size:", ";line-height:", ";border-radius:", ";transition:background-color ", ";"], getSpacing(1), getSpacing(1), colorUsage.searchItemList.titleColor, fontSize.normal, lineHeight.normal, borderRadius.medium, transitionDuration["default"]);
var Title = styled.div.withConfig({
  displayName: "SearchItemListstyle__Title",
  componentId: "sc-1di9gp6-5"
})([""]);
var SubTitle = styled.div.withConfig({
  displayName: "SearchItemListstyle__SubTitle",
  componentId: "sc-1di9gp6-6"
})(["height:", ";overflow:hidden;color:", ";"], lineHeight.normal, colorUsage.searchItemList.subTitleColor);
var Item = styled.div.withConfig({
  displayName: "SearchItemListstyle__Item",
  componentId: "sc-1di9gp6-7"
})(["display:flex;align-items:center;&:not(:first-child){margin-top:", ";}&:hover{cursor:pointer;}&:hover ", "{background-color:", ";}&:hover ", "{opacity:1;}"], getSpacing(2), TextWrapper, colorUsage.searchItemList.hoverItemBackgroundColor, IconWrapper);
export { Container, IconWrapper, Item, Image, ImageWrapper, SubTitle, TextWrapper, Title };